// src/store/slices/positionsSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialPositions = [
    {
        id: 1,
        gemId: 14,
        number: 3,
        name: '3 Basic',
        minParticipantsCount: 200,
        minPrizePlacesCount: 50,
        promoType: 'crystalsAndCrypto',
        defaultBudget: '100.00',
        defaultTokenType: 'USDT',
        presets: [
            { win: 10, budget_percent: 33 },
            { win: 23, budget_percent: 33 },
            { win: 67, budget_percent: 34 },
        ],
        createdAt: '2025-05-31T12:39:04.230Z',
        updatedAt: '2025-05-31T13:24:40.992Z',
    },
];

const initialState = {
    positions: initialPositions,
    loading: false,
    error: null,
};

const positionsSlice = createSlice({
    name: 'positions',
    initialState,
    reducers: {
        setPositions(state, action) {
            state.positions = action.payload;
            state.error = null;
        },
        addPosition(state, action) {
            state.positions.push(action.payload);
            state.error = null;
        },
        updatePosition(state, action) {
            const updated = action.payload;
            const index = state.positions.findIndex((p) => p.id === updated.id);
            if (index !== -1) {
                state.positions[index] = {
                    ...state.positions[index],
                    ...updated,
                    updatedAt: new Date().toISOString(),
                };
                state.error = null;
            } else {
                state.error = `Position с id=${updated.id} не найдена`;
            }
        },
        deletePosition(state, action) {
            const idToDelete = action.payload;
            state.positions = state.positions.filter((p) => p.id !== idToDelete);
            state.error = null;
        },
        clearError(state) {
            state.error = null;
        },
    },
});

export const {
    setPositions,
    addPosition,
    updatePosition,
    deletePosition,
    clearError,
} = positionsSlice.actions;

export default positionsSlice.reducer;
